import script from "./register-form.vue?vue&type=script&setup=true&lang=js"
export * from "./register-form.vue?vue&type=script&setup=true&lang=js"

import "./register-form.vue?vue&type=style&index=0&id=1c182cd2&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c182cd2"]])

export default __exports__